import React from 'react'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import AccommodationRoomTile from 'components/AccommodationKit/AccommodationRoomTile'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import BedbankAboutRoomModalTab from './BedbankAboutRoomModalTab'
import ModalBase from 'LuxKit/Modal/ModalBase'

interface Props {
  roomPackage: App.BedbankPackage;
  showBookmark?: boolean;
}

function BedbankRoomDetailsModal(props: Props) {
  const { roomPackage, showBookmark } = props

  if (!roomPackage) return null

  return (<ModalBase mode="drawer">
    <ModalHeader title={roomPackage.name} />
    <ModalBody>
      <AccommodationRoomTile roomPackage={roomPackage}>
        <AccommodationRoomTileImage roomPackage={roomPackage} showBookmark={showBookmark} />
      </AccommodationRoomTile>
      <BedbankAboutRoomModalTab roomPackage={roomPackage} />
    </ModalBody>
  </ModalBase>)
}

export default BedbankRoomDetailsModal
